export default __webpack_public_path__ + "static/media/Head_4_Ear_1_C4.4b1580e0.svg";